<template>
  <div class="field">
    <input
      v-validate="validation"
      :data-vv-as="label"
      :type="type"
      :class="classes"
      :name="name"
      :min="min"
      :value="value"
      @input="$emit('updateValue', $event.target.value)"
      :readonly="readonly"
    >
    <label :for="name" data-tid="card_number_label">{{ label }}</label>
    <div class="baseline"></div>
    <span class="info" :class="{error: errors.has(name)}">{{errors.first(name)}}</span>
  </div>
</template>

<script>
const inputTypes = ['text', 'tel', 'number', 'email', 'password', 'date', 'file', 'hidden']

export default {
  name: 'material-input',
  inject: ['$validator'],
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text',
      validator: function(value) {
        return inputTypes.indexOf(value) > -1
      }
    },
    min: {
      type: String,
      required: false
    },
    value: {
      required: true
    },
    name: {
      required: true
    },
    validation: {
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'updateValue'
  },
  computed: {
    classes: function() {
      return {
        'read-only': this.readonly,
        input: true,
        empty: !this.value || this.value.length === 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.field {
  position: relative;
  // width: 100%;
  height: 50px;
}

.field.half-width {
  width: 50%;
}

.field.quarter-width {
  width: calc(25% - 10px);
}

.baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #cfd7df;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 4px;
  color: #cfd7df;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  pointer-events: none;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}

label:not([readonly]) {
  cursor: text;
}

.input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 6px;
  color: #32325d;
  background-color: transparent;
}

.input:read-only {
  cursor: default;
}

.input::-webkit-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input::-moz-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input:-ms-input-placeholder {
  color: transparent;
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.input {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.input:focus,
.input:not(.empty) {
  opacity: 1;
}

.input:focus::-webkit-input-placeholder,
.input:not(.empty)::-webkit-input-placeholder {
  color: #cfd7df;
}

.input:focus::-moz-placeholder,
.input:not(.empty)::-moz-placeholder {
  color: #cfd7df;
}

.input:focus:-ms-input-placeholder,
.input:not(.empty):-ms-input-placeholder {
  color: #cfd7df;
}

.input:focus:not([readonly]) ~ label,
.input:not(.empty) ~ label {
  color: #aab7c4;
  transform: scale(0.85) translateY(-21px);
  cursor: default;
}

.input:focus:not([readonly]) ~ label {
  color: #24b47e;
}

.input.invalid ~ label {
  color: #ffa27b;
}

.input:focus:not([readonly]) ~ label ~ .baseline {
  background-color: #24b47e;
}

.input:focus.invalid ~ label ~ .baseline {
  background-color: #e25950;
}

input {
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  border-style: none;
}

input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  transition: background-color 100000000s;
  -webkit-animation: 1ms void-animation-out;
}

.StripeElement--webkit-autofill {
  background: transparent !important;
}

input {
  -webkit-animation: 1ms void-animation-out;
}

.info {
  position: absolute;
  bottom: -17px;
  font-size: 10px;
  white-space: nowrap;

  &.error {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/Material.vue